import { render, staticRenderFns } from "./faceRecognition.vue?vue&type=template&id=1c3b00d5&"
import script from "./faceRecognition.vue?vue&type=script&lang=js&"
export * from "./faceRecognition.vue?vue&type=script&lang=js&"
import style0 from "./faceRecognition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports